import { NoSsr } from '@cian/react-utils';
import { UIHeading2, LinkButton, ModalWindow, UIText2, Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './FoldersUnsupportedModal.css';
import smile from './assets/smile.png';

export interface IFoldersUnsupportedModalProps {
  url: string;
  isOpen: boolean;
  onClose(): void;
  onClick(): void;
}

export const FoldersUnsupportedModal = ({ url, isOpen, onClose, onClick }: IFoldersUnsupportedModalProps) => (
  <NoSsr>
    <ModalWindow open={isOpen} onClose={onClose}>
      <div className={styles['container']}>
        <div className={styles['image']}>
          <Image width={64} src={smile} />
        </div>
        <div className={styles['header']}>
          <UIHeading2 textAlign="center">Подборки можно посмотреть в&nbsp;приложении</UIHeading2>
        </div>
        <div className={styles['subheader']}>
          <UIText2 textAlign="center">
            Всё, что вам понравилось, мы сохранили в&nbsp;избранном&nbsp;&#10084;&#65039;
          </UIText2>
        </div>
        <div className={styles['button']}>
          <LinkButton onClick={onClick} href={url}>
            Открыть приложение
          </LinkButton>
        </div>
      </div>
    </ModalWindow>
  </NoSsr>
);
